import React from 'react'

import * as S from './styled'

const WindowHeader = () => {

  return (
    <S.WindowHeader id='window-header'>
      <S.Title id='header-title'>Informações rápidas</S.Title>
    </S.WindowHeader>
  )
}

export default WindowHeader
